<div class="company-widget-container tcm-details-panel mb-4" *ngIf="viewModel">
  <div class="info-container">
    <div class="section logo">
      <div class="photo-wrapper">
        <img class="company-logo" src="{{viewModel.logo || '/assets/images/no-photo.jpg'}}" />
        <div class="upload-logo" *ngIf="canUpdatePhoto">
          <a href="#" oncontextmenu="return false;" (click)="openUplaodLogoModal($event)">
            {{'Screens.Companies.InfoWidget.Update' | translate}}
          </a>
        </div>
      </div>
    </div>
    <div class="section info"></div>
    <div class="section company-info">
      <span class="section-header">{{ viewModel.name }}</span>
      <hr />
      <div class="description">
        <div *ngIf="viewModel.saleGlAccount">
          {{'Screens.Companies.Search.Columns.PatientSaleGlAccount' | translate}}: {{ viewModel.saleGlAccount }}
        </div>
        <div *ngIf="viewModel.discountGlAccount">
          {{'Screens.Companies.Search.Columns.PatientDiscountGlAccount' | translate}}: {{ viewModel.discountGlAccount }}
        </div>
      </div>
    </div>
  </div>
</div>
